import { render, staticRenderFns } from "./RestrictedLink.vue?vue&type=template&id=449ddeea"
import script from "./RestrictedLink.vue?vue&type=script&lang=js"
export * from "./RestrictedLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports